import React from 'react';

import Button from 'components/button/button';
import Icon from 'components/icon/icon';
import Typography from 'components/typography/typography';
import useRedirect from 'hooks/use-redirect';
import { createLocale } from 'locales';

const globalLocalize = createLocale('global');

const FreelancerJobsError: React.FC = () => {
  const redirect = useRedirect();

  const onNavigateToFreelancerDashboardlicked = () => {
    redirect('/freelancer/');
  };
  const onReloadPageClicked = () => {
    window.location.reload();
  };

  return (
    <div className="flex flex-col justify-center items-center w-screen h-screen gap-y-10">
      <div className="relative flex flex-col justify-center">
        <Icon
          icon="ant-design_filter-outlined"
          size={160}
          className="text-gray600"
        />
        <Icon
          icon="info-circle-1"
          size={56}
          className="text-tomato-red absolute top-[46%] right-[14%] rotate-180 rounded-full"
        />
      </div>
      <div className="flex flex-col items-center text-center gap-y-8">
        <div className="flex flex-col gap-y-3">
          <Typography variant="page-heading" as="p" className="text-gray800">
            {globalLocalize('pageDidntLoad')}
          </Typography>
          <Typography variant="body-large" as="p" className="text-gray500">
            {globalLocalize('sorryPageDidntLoadTryAgain')}
          </Typography>
        </div>
        <div className="flex gap-x-8">
          <Button
            onClick={onNavigateToFreelancerDashboardlicked}
            label={globalLocalize('navigateToDashboard')}
            variant="outlined"
          />
          <Button
            onClick={onReloadPageClicked}
            label={globalLocalize('ReloadPage')}
            variant="primary"
          />
        </div>
      </div>
    </div>
  );
};

export default FreelancerJobsError;
